export const DOC_DETAILS = {
  BANK_STATEMENT: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  PAYSLIP: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  EMPLOYMENT_CONTRACT: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  TAX_RETURN: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  SALE_AGREEMENT: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  LOAN_AGREEMENT: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  GIFT_INHERITANCE: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  BUSINESS_OWNERSHIP: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  PROOF_OF_ADDRESS: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  IDENTITY_DOCUMENT: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
  OTHER: {
    allowedTypes: ['pdf', 'csv', 'xlsx', 'xls'],
    allowedSize: 2097152,
  },
};